import { computed, unref } from "vue";
import { getProductRoute } from "../utilities";
import type { ComputedRef, MaybeRef } from "vue";
import type { RouteLocationRaw } from "vue-router";

export function useProductsRoutes(
  products: MaybeRef<Record<string, unknown>[]>,
  options: { productIdProperty?: string; slugProperty?: string } = {},
): ComputedRef<Record<string, RouteLocationRaw>> {
  const { productIdProperty = "id", slugProperty = "slug" } = options;

  return computed(() =>
    unref(products).reduce<Record<string, RouteLocationRaw>>((result, item) => {
      const productId = item[productIdProperty] as string | undefined;
      const productSlug = item[slugProperty] as string | undefined;
      if (!productId || typeof productId !== "string") {
        return result;
      }
      result[productId] = getProductRoute(productId, productSlug);
      return result;
    }, {}),
  );
}
